@if (column(); as column) {
  @if (model(); as model) {
    @switch (column.key) {
      @case (getColumnKey('logoUrl')) {
        @if (isNotNil(model.logoUrl)) {
          <app-image-thumbnail>
            <img
              [ngSrc]="model.logoUrl"
              [fill]="true"
              [alt]="model.logoAlt"
              class="object-contain" />
          </app-image-thumbnail>
        } @else {
          <app-image-thumbnail-unsupported />
        }
      }

      @case (getColumnKey('homeUrl')) {
        @if (isNotNil(model.homeUrl)) {
          <app-external-link [link]="model.homeUrl">
            {{ model.homeUrl }}
          </app-external-link>
        } @else {
          <app-no-data />
        }
      }

      @case (getColumnKey('status')) {
        @if (isNotNil(model.status)) {
          {{ model.status | adminBrandStatus | async }}
        } @else {
          <app-no-data />
        }
      }

      @default {
        <app-table-body-no-reference-cell [columnKey]="column.key" />
      }
    }
  }
}
